import { NgModule } from '@angular/core';
import { PreloadAllModules, RouterModule, Routes } from '@angular/router';
import { AuthGuardService } from './services/guards/auth-guard.service';

const routes: Routes = [
  { path: '', redirectTo: 'dashboard', pathMatch: 'full' },
  {
    path: 'login',
    loadChildren: () => import('./pages/login/login.module').then(m => m.LoginPageModule)
  },
  {
    path: 'registration',
    loadChildren: () => import('./pages/registration/registration.module').then(m => m.RegistrationPageModule)
  },
  {
    path: 'dashboard',
    loadChildren: () => import('./pages/dashboard/dashboard.module').then(m => m.DashboardPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'forgot-password',
    loadChildren: () => import('./pages/forgot-password/forgot-password.module').then(m => m.ForgotPasswordPageModule)
  },
  {
    path: 'profile',
    loadChildren: () => import('./pages/profile/profile.module').then(m => m.ProfilePageModule)
  },
  {
    path: 'mydealers',
    loadChildren: () => import('./pages/my-dealer/my-dealer.module').then(m => m.MyDealerPageModule)
  },
  {
    path: 'news',
    loadChildren: () => import('./pages/news/news.module').then(m => m.NewsPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'survey',
    loadChildren: () => import('./pages/survey/survey.module').then(m => m.SurveyPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'mytractors',
    loadChildren: () => import('./pages/my-tractors/my-tractors.module').then(m => m.MyTractorsPageModule)
  },
  {
    path: 'privacy-policy',
    loadChildren: () => import('./pages/privacy-policy/privacy-policy.module').then(m => m.PrivacyPolicyPageModule)
  },
  {
    path: 'tractor_promotion',
    loadChildren: () => import('./pages/tractor-promotions/tractor-promotions.module').then(m => m.TractorPromotionsPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'promotions',
    loadChildren: () => import('./pages/dealer-promotions/dealer-promotions.module').then(m => m.DealerPromotionsPageModule),
    canActivate: [AuthGuardService]
  },
  {
    path: 'promo-details/:promoId',
    loadChildren: () => import('./pages/shared/promo-details/promo-details.module').then(m => m.PromoDetailsPageModule)
  },
  {
    path: 'scan-btm',
    loadChildren: () => import('./pages/btm/scan-btm/scan-btm.module').then(m => m.ScanBtmPageModule)
  },
  {
    path: 'btm-dashboard',
    loadChildren: () => import('./pages/btm/btm-dashboard/btm-dashboard.module').then(m => m.BtmDashboardPageModule)
  }
  // {
  //   path: 'add-new-btm',
  //   loadChildren: () => import('./pages/btm/add-new-btm/add-new-btm.module').then( m => m.AddNewBtmPageModule)
  // }
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, { preloadingStrategy: PreloadAllModules })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
